import { ControlInput, FormValidationRule } from "../types";

export const isValidName = (name : string) => {
    return /^[a-zA-Z\-'\sdÀÈÌÒÙàèìòùÁÉÍÓÚÝáéíóúýÂÊÎÔÛâêîôûÃÑÕãñõÄËÏÖÜäëïöüçÇßØøÅåÆæÞþÐð.]*$/g.test(name);
}

const hasEmptyRequiredName = (
    inputs: Array<ControlInput> | null | undefined,
    value : { [s: string]: string; }
) => {
    return !inputs || !value[inputs[1].id] || !value[inputs[3].id];
}

const hasNonEmptyName = (
    value : { [s: string]: string; }
) => {
    return !(Object.values(value).every(
        element => element === ""
    ));
}

const hasInvalidName = (value: { [s: string]: string; }) => {
    return !(Object.values(value).every(
        element =>
            isValidName(element)
    ));
}

const validName: FormValidationRule = (control, value) => {
    let valid = true;

    if (value && control && control.type === "name") {
        if (((control.isRequired || hasNonEmptyName(value)) &&
            hasEmptyRequiredName(control.inputs, value))
            || hasInvalidName(value)) {
                valid = false;
        }
    }

    return [valid, ""];
};

export default validName;
